import graphqlClient from "@/GQLClient";
import type { ProfileFragment } from "@/graphql";
import {
  type EmployeeInput,
  GetProfilesDocument,
  type GetProfilesQueryVariables,
  SaveProfileDocument,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const save = async (employee: EmployeeInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveProfileDocument,
    variables: {
      employee,
    },
  });

  if (response.data?.user?.saveProfile?.success) {
    return response;
  }

  throw new SentryGraphQLError();
};

const getProfiles = async (
  variables: GetProfilesQueryVariables,
): Promise<ProfileFragment[]> => {
  const response = await graphqlClient.query({
    query: GetProfilesDocument,

    variables,
  });

  if (response.error) {
    throw new SentryGraphQLError();
  }

  return (response.data.profiles || []) as ProfileFragment[];
};

export default {
  save,
  getProfiles,
};
